import { ref } from 'vue';
import { createGlobalState } from '@vueuse/core';
import type { IProjectInfo } from '@/types';

export const useGlobalState = createGlobalState(
    () => {
        const project = ref<IProjectInfo>();
        const isAirProduct = ref(false);

        function updateProjectInfo(projectInfo: Partial<IProjectInfo>) {
            project.value = {
                ...project.value,
                ...projectInfo,
            }
        }

        function updateIsAirProduct(value: boolean) {
            isAirProduct.value = value;
        }

        return {
            project,
            updateProjectInfo,
            isAirProduct,
            updateIsAirProduct,
        }
    }
)
